/* eslint-disable jsx-a11y/anchor-is-valid */
import { globalVariables } from "helper/globalVariables";
import { Button } from "shared/Components/button";
import { downloadWhite, shareWhite } from "helper/icons";
import { useMediaQuery } from "react-responsive";
export const TrialDetailCard = ({ judgeDetail }) => {
  const isSmallMobile = useMediaQuery({ query: "(max-width: 320px)" });

  return (
    <div class={`bg-white ${isSmallMobile ? "w-70 pb-2" : "w-80"}`}>
      <div class="flex justify-start flex-col mt-5 pb-3">
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.judgeName}
          </span>
          <span className="text-md">{judgeDetail.name}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.phoneNumber}
          </span>
          <span className="text-md">{judgeDetail.phoneNumber}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.email}</span>
          <span className="text-md">{judgeDetail.email}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.address}
          </span>
          <span className="text-md">{judgeDetail.address}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">{globalVariables.level}</span>
          <span className="text-md">{judgeDetail.level}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.distanceReadyToTravel}
          </span>
          <span className="text-md">{judgeDetail.distance}</span>
        </div>
        <div className="flex flex-col mb-4">
          <span className="text-xs text-gray-600">
            {globalVariables.numberOfRailJudge}
          </span>
          <span className="text-md">{judgeDetail.numberOfTrials}</span>
        </div>
      </div>
    </div>
  );
};
